import React, { useState } from 'react';
import { Tabs, Typography } from 'antd';
import DispatchEventTaskTab from './components/DispatchEventTaskTab';
import DispatchEventTaskOrderTab from './components/DispatchEventTaskOrderTab';
import DispatchEventTaskOrderHistoryTab from './components/DispatchEventTaskOrderHistoryTab';

const { Title } = Typography;

const DispatchToolPage: React.FC = () => {
    const [activeKey, setActiveKey] = useState('event-task');
    const [link, setLink] = useState<{ taskId: number; seq: number }>();
    const [historyLink, setHistoryLink] = useState<{ taskId: number; seq: number }>();

    // 已归档任务的明细在归档表，跳 Tab3；未归档跳 Tab2
    const handleViewOrders = (dispatchEventTaskId: number, archived: boolean) => {
        if (archived) {
            setHistoryLink((prev) => ({ taskId: dispatchEventTaskId, seq: (prev?.seq ?? 0) + 1 }));
            setActiveKey('event-task-order-history');
            return;
        }
        setLink((prev) => ({ taskId: dispatchEventTaskId, seq: (prev?.seq ?? 0) + 1 }));
        setActiveKey('event-task-order');
    };

    return (
        <div className="p-6 space-y-4">
            <Title level={4}>调度工具</Title>
            <Tabs
                className="mt-4"
                activeKey={activeKey}
                onChange={(key) => {
                    // 手动切 Tab 清掉联动条件，重挂载后按默认条件查询；联动跳转走 handleViewOrders 不触发 onChange
                    setLink(undefined);
                    setHistoryLink(undefined);
                    setActiveKey(key);
                }}
                destroyInactiveTabPane
                items={[
                    {
                        key: 'event-task',
                        label: '调度任务',
                        children: <DispatchEventTaskTab onViewOrders={handleViewOrders} />,
                    },
                    {
                        key: 'event-task-order',
                        label: '调度任务订单',
                        children: <DispatchEventTaskOrderTab linkedTaskId={link?.taskId} linkSeq={link?.seq} />,
                    },
                    {
                        key: 'event-task-order-history',
                        label: '调度任务订单（归档）',
                        children: (
                            <DispatchEventTaskOrderHistoryTab
                                linkedTaskId={historyLink?.taskId}
                                linkSeq={historyLink?.seq}
                            />
                        ),
                    },
                ]}
            />
        </div>
    );
};

export default DispatchToolPage;
